// 'progress' namespace — keys are prefixed 'progress.'. Russian is the primary UI language.
const ru: Record<string, string> = {
  'progress.subtitle': 'Как меняется ваше письмо — по всем проверенным попыткам',
  'progress.emptyTitle': 'Статистики пока нет',
  'progress.emptyText': 'Сдайте первую работу — и здесь появятся точность, тоносы и повторяющиеся ошибки.',
  'progress.startFirst': 'Начать с копирования',
  'progress.totals.sessions': 'Попыток',
  'progress.totals.submitted': 'Отправлено',
  'progress.totals.words': 'Слов написано',
  'progress.totals.minutes': 'Минут письма',
  'progress.totals.streak': 'Серия',
  'progress.day.one': 'день',
  'progress.day.few': 'дня',
  'progress.day.many': 'дней',
  'progress.copyTrend': 'Точность копирования',
  'progress.copyTrendNote': 'По последней оценке каждой попытки копирования и воспроизведения',
  'progress.copyTrendAria': 'График точности копирования по {n} попыткам: буквы, тоносы, пунктуация',
  'progress.freeTrend': 'Свободное письмо и экзамен',
  'progress.freeTrendNote': 'Учебная оценка в процентах от максимума — не официальный балл',
  'progress.freeTrendAria': 'График учебной оценки свободного письма по {n} попыткам',
  'progress.series.char': 'Буквы',
  'progress.series.accent': 'Тоносы',
  'progress.series.punct': 'Пунктуация',
  'progress.series.score': 'Учебная оценка',
  'progress.noCopy': 'Пока нет проверенных попыток копирования.',
  'progress.noFree': 'Пока нет оценённых свободных текстов.',
  'progress.categories': 'Типы ошибок',
  'progress.categoriesNote': 'Сколько раз встречалась каждая ошибка в последних оценках',
  'progress.categoriesAria': 'Диаграмма: количество ошибок по типам',
  'progress.count': 'Количество',
  'progress.noIssues': 'Ошибок пока не найдено.',
  'progress.repeated': 'Повторяющиеся ошибки',
  'progress.repeatedNote': 'Слова, в которых ошибка повторилась минимум в двух попытках',
  'progress.noRepeated': 'Повторяющихся ошибок нет — так держать.',
  'progress.col.word': 'Слово',
  'progress.col.type': 'Тип',
  'progress.col.occurrences': 'Раз',
  'progress.col.sessions': 'Попыток',
  'progress.col.lastSeen': 'Последний раз',
  'progress.perTask': 'По текстам',
  'progress.perTaskNote': 'Точность букв: лучшая и последняя попытка',
  'progress.noTasks': 'Пока нет попыток по текстам из библиотеки.',
  'progress.col.task': 'Текст',
  'progress.col.attempts': 'Попыток',
  'progress.col.best': 'Лучшая',
  'progress.col.last': 'Последняя',
  'progress.personalBest': 'Личный рекорд',
  'progress.disclaimer':
    'Вся статистика учебная: точность копирования и оценки по учебной шкале A2 не являются официальными экзаменационными баллами.',
  'progress.cat.accent': 'Тонос',
  'progress.cat.spelling': 'Орфография',
  'progress.cat.final_sigma': 'Конечная сигма',
  'progress.cat.article': 'Артикль',
  'progress.cat.agreement': 'Согласование',
  'progress.cat.noun_case': 'Падеж',
  'progress.cat.verb_form': 'Форма глагола',
  'progress.cat.word_order': 'Порядок слов',
  'progress.cat.punctuation': 'Пунктуация',
  'progress.cat.register': 'Стиль и регистр',
  'progress.cat.vocabulary': 'Лексика',
  'progress.cat.task_coverage': 'Выполнение задания',
  'progress.cat.other': 'Другое',
};
const en: Record<string, string> = {
  'progress.subtitle': 'How your writing is changing — across all checked attempts',
  'progress.emptyTitle': 'No statistics yet',
  'progress.emptyText': 'Submit your first piece — accuracy, tonos and repeated mistakes will appear here.',
  'progress.startFirst': 'Start with copying',
  'progress.totals.sessions': 'Attempts',
  'progress.totals.submitted': 'Submitted',
  'progress.totals.words': 'Words written',
  'progress.totals.minutes': 'Minutes writing',
  'progress.totals.streak': 'Streak',
  'progress.day.one': 'day',
  'progress.day.few': 'days',
  'progress.day.many': 'days',
  'progress.copyTrend': 'Copying accuracy',
  'progress.copyTrendNote': 'Latest evaluation of each copy and recall attempt',
  'progress.copyTrendAria': 'Copying accuracy over {n} attempts: letters, tonos, punctuation',
  'progress.freeTrend': 'Free writing & exam',
  'progress.freeTrendNote': 'Practice score as a share of the maximum — not an official grade',
  'progress.freeTrendAria': 'Practice score of free writing over {n} attempts',
  'progress.series.char': 'Letters',
  'progress.series.accent': 'Tonos',
  'progress.series.punct': 'Punctuation',
  'progress.series.score': 'Practice score',
  'progress.noCopy': 'No checked copy attempts yet.',
  'progress.noFree': 'No evaluated free texts yet.',
  'progress.categories': 'Mistake types',
  'progress.categoriesNote': 'How often each mistake occurred in the latest evaluations',
  'progress.categoriesAria': 'Bar chart: number of mistakes by type',
  'progress.count': 'Count',
  'progress.noIssues': 'No mistakes found yet.',
  'progress.repeated': 'Repeated mistakes',
  'progress.repeatedNote': 'Words where the same mistake appeared in at least two attempts',
  'progress.noRepeated': 'No repeated mistakes — keep it up.',
  'progress.col.word': 'Word',
  'progress.col.type': 'Type',
  'progress.col.occurrences': 'Times',
  'progress.col.sessions': 'Attempts',
  'progress.col.lastSeen': 'Last seen',
  'progress.perTask': 'By text',
  'progress.perTaskNote': 'Letter accuracy: best and latest attempt',
  'progress.noTasks': 'No attempts on library texts yet.',
  'progress.col.task': 'Text',
  'progress.col.attempts': 'Attempts',
  'progress.col.best': 'Best',
  'progress.col.last': 'Latest',
  'progress.personalBest': 'Personal best',
  'progress.disclaimer':
    'All statistics are for practice: copying accuracy and A2 practice-rubric scores are not official exam grades.',
  'progress.cat.accent': 'Tonos',
  'progress.cat.spelling': 'Spelling',
  'progress.cat.final_sigma': 'Final sigma',
  'progress.cat.article': 'Article',
  'progress.cat.agreement': 'Agreement',
  'progress.cat.noun_case': 'Noun case',
  'progress.cat.verb_form': 'Verb form',
  'progress.cat.word_order': 'Word order',
  'progress.cat.punctuation': 'Punctuation',
  'progress.cat.register': 'Register',
  'progress.cat.vocabulary': 'Vocabulary',
  'progress.cat.task_coverage': 'Task coverage',
  'progress.cat.other': 'Other',
};
export default { ru, en };
